import { errorClassName } from '../Other';
export const scrollIntoView = () => {
  setTimeout(() => {
    // 多个表格，需要用context获取表格根节点，这里暂时没有写
    const element = document.querySelector(`.${errorClassName}`);

    if (element && element.scrollIntoView) {
      element.scrollIntoView({
        behavior: 'smooth',
        block: 'center',
        inline: 'start'
      });
    }
  }, 200);
};
//# sourceMappingURL=es/utils/scrollIntoView.js.map